// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__3--63","white":"menu_white__fe1cu","black":"menu_black__dUI68"};